<div class="custom-translation-btn" [title]="tooltip" (click)="onBtnClick()">
  {{ visibleLangCode.toUpperCase() }}
</div>
